/**
 * App.js
 *
 * Copyright (c) apploft. GmbH
 */

import React from 'react';
// @ts-ignore
import api from './de.apploft.generated/api.json';
// @ts-ignore
import colors from './assets/colors.json';
// @ts-ignore
import strings from './assets/strings.json';
import './App.css';
import {Theme} from 'apploft-cloud-forms';
import Portal from './Portal/Portal';
import OidcService from 'apploft-cloud-client/src/oidc-service';
// @ts-ignore
import oidcConfig from './assets/oidc.json';
import {LoginStrategy} from './Portal/LoginStrategy';

function App() {
  const loginConfig = undefined;
  // const loginConfig = {
  //   strategy: LoginStrategy.OIDC,
  //   service: new OidcService(oidcConfig),
  // };
  return (
    <React.StrictMode>
      <Theme colors={colors} strings={strings}>
        <Portal api={api} loginConfig={loginConfig} />
      </Theme>
    </React.StrictMode>
  );
}

export default App;
